import React, { useState } from 'react'
import { useEffect } from 'react';
import Chart from "react-google-charts";
// import data from '../../../../unified-dashboard/src/features/maxClassSchedule/placeHolderData';



function MetricGraph({ name, progressData, hasNotes, assessment }) {
  let bodyPartName = name
  let progressDataGraph = progressData
  let graphData = []
  
  //sets the width of the graph to fill the card
  // if no notes on progress entries
  let graphWidth = '80%'
  let divWidth = '45vw'
  if(!hasNotes){
    graphWidth = '20vw'
    divWidth = '50vw'
  }

  const[lowestVal,setLowestVal] = useState(Infinity)

  // if a single progress entry, sets a single horizontal grid point
  // and puts it inside the graph (otherwise it looks weird)
  let gridLineNumber = -1
  let gridText = 'out'
  if(progressData.length===1){
    gridLineNumber=0
    gridText='in'
  }
  
  const colors = [
    '#0C69E8',
    '#0CAAF2',
    '#00D1DB',
    '#0CF2BD',
    '#0CE877'
  ] //analogous blue-green colors
  
  let randomColor = colors[Math.floor(Math.random() * 4)]

  const secondsToTime = seconds => {
    const m = Math.floor(seconds/60)
    const s = seconds - m*60
    const ss = s < 10 ? `0${s}`  : s
    return `${m}:${ss}`
  }
  let date;
  if (progressDataGraph) {
    if(assessment.unit === 'time'){
      graphData.push([{ type: 'date', label: 'Day' }, "seconds",{  role: "annotation", type: 'string', label: 'Time' }])
      progressDataGraph.forEach(data => {
        if(data.value<lowestVal){ //finds lowest value to set minimum Y axis value
          setLowestVal(data.value)
        }
        date = new Date(data.date)
        date.setUTCDate(date.getUTCDate() + 1) 
        graphData.push([date, data.value, secondsToTime(data.value)])
      })

    } else {
      graphData.push([{ type: 'date', label: 'Day' }, bodyPartName])
      progressDataGraph.forEach(data => {
        if(data.value<lowestVal){ //finds lowest value to set minimum Y axis value
          setLowestVal(data.value)
        }
        date = new Date(data.date)
        date.setUTCDate(date.getUTCDate() + 1) 
        graphData.push([date, data.value])
      })
    }
  }

  // {
  //   assessment.unit === 'time' ?
  //   secondsToTime(progress.value) :
  //   progress.value
  // }
  const vAxis =()=> {
    if(assessment.unit === 'time'){
      return { 
        minValue: 0,
        viewWindow: {
          min:lowestVal
        },
        title: 'Time (seconds)',
      }
    } else {
      return { 
        minValue: 0,
        viewWindow: {
          min:lowestVal
        }
      }
    }
  }

  return (
    <div style={{width:divWidth}}>
        <Chart
          // width={'auto'}
          height={'33vh'}
          backgroundColor={"transparent"}
          chartType="AreaChart"
          loader={<div>Loading Chart</div>}
          data={graphData}

          options={{
            legend:'none',
            hAxis: {  
              titleTextStyle: { color: randomColor },
              format:'MMM d, y', 
              gridlines: {
                count:gridLineNumber
              },
              textPosition:gridText
            },
            vAxis: vAxis(),
            
            // vAxis: { 
            //   minValue: 0,
            //   viewWindow: {
            //     min:lowestVal
            //   },
              
            // },
            chartArea: { width: graphWidth, height: '80%' },
            explorer: { 
                actions: ['dragToZoom', 'rightClickToReset'],
                axis: 'horizontal',
                keepInBounds: true,
                maxZoomIn: 4.0
            },
            colors: [randomColor],
            annotations: {
              textStyle: {
                // fontName: 'Times-Roman',
                // fontSize: 18,
                // bold: true,
                // italic: true,
                // The color of the text.
                color: 'black',
                // The color of the text outline.
                auraColor: 'white',
                // The transparency of the text.
                opacity: 0.8
              }
            },
            maintainAspectRatio:true,
            responsive:true,
          }}
          
        />
    </div>
  )
}

export default MetricGraph
